(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craftly-how-it-works"] && !Shopify.designMode) return;
  try {
    
  /**
   * Loads and plays the looping media clip only once it's near the viewport,
   * and pauses it off-screen. Under prefers-reduced-motion it stays on the
   * poster frame and gets native controls instead of autoplaying.
   */
  if (!customElements.get('craftly-loop-video')) {
    customElements.define(
      'craftly-loop-video',
      class CraftlyLoopVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.controls = true;
            this.video.removeAttribute('aria-hidden');
            this.#loadSources();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (entry.isIntersecting) {
                  this.#loadSources();
                  this.video.play().catch(() => {});
                } else {
                  this.video.pause();
                }
              }
            },
            { rootMargin: '200px 0px' }
          );
          // Observe the <video>, not the host: the wrapper is display: contents,
          // so it has no box and would never report an intersection.
          this.observer.observe(this.video);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        #loadSources() {
          if (this.loaded) return;
          this.loaded = true;
          if (this.video.dataset.poster) this.video.poster = this.video.dataset.poster;
          for (const source of this.video.querySelectorAll('source[data-src]')) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          }
          this.video.load();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["craftly-reviews"] && !Shopify.designMode) return;
  try {
    
  /**
   * Clamps a review to four lines and reveals "Skaityti daugiau" only when
   * the text really is longer than that; the button then toggles it open.
   */
  if (!customElements.get('craftly-review-text')) {
    customElements.define(
      'craftly-review-text',
      class CraftlyReviewText extends HTMLElement {
        connectedCallback() {
          this.text = this.querySelector('.craftly-review__text');
          this.button = this.querySelector('.craftly-review__more');
          if (!this.text || !this.button) return;

          this.toggleAttribute('data-clamped', true);
          if (this.text.scrollHeight - this.text.clientHeight < 2) {
            this.removeAttribute('data-clamped');
            return;
          }

          this.button.hidden = false;
          this.button.addEventListener('click', () => {
            const expanded = this.toggleAttribute('data-clamped');
            this.button.setAttribute('aria-expanded', String(!expanded));
            this.button.textContent = expanded ? 'Skaityti daugiau' : 'Rodyti mažiau';
          });
        }
      }
    );
  }

  /**
   * Prev/next arrows for the horizontally scrolling review row. Each click
   * moves one card and the row loops: past the last card it rewinds to the
   * first, and back from the first it jumps to the end. Both arrows show
   * whenever the row overflows.
   */
  if (!customElements.get('craftly-review-scroller')) {
    customElements.define(
      'craftly-review-scroller',
      class CraftlyReviewScroller extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.craftly-reviews__track');
          this.arrows = this.querySelectorAll('.craftly-reviews__arrow');
          if (!this.track) return;

          this.arrows.forEach((arrow) => arrow.addEventListener('click', this.#scroll));
          this.resizeObserver = new ResizeObserver(this.#update);
          this.resizeObserver.observe(this.track);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        #scroll = (event) => {
          const direction = Number(event.currentTarget.dataset.direction);
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const end = scrollWidth - clientWidth;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

          if (direction > 0 && scrollLeft >= end - 2) {
            this.track.scrollTo({ left: 0, behavior });
            return;
          }
          if (direction < 0 && scrollLeft <= 2) {
            this.track.scrollTo({ left: end, behavior });
            return;
          }

          const card = this.track.querySelector('.craftly-review');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = card ? card.getBoundingClientRect().width + gap : clientWidth;
          this.track.scrollBy({ left: direction * step, behavior });
        };

        #update = () => {
          const overflows = this.track.scrollWidth - this.track.clientWidth > 2;
          this.arrows.forEach((arrow) => arrow.toggleAttribute('hidden', !overflows));
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
